import axios from 'axios';

export const API_URL = 'https://api.touchdownleague.com/api';

// Request interceptor - Add auth token to all requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - Handle 401/403 errors (expired/invalid tokens)
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      const errorData = error.response?.data;

      // Don't reload if it's an email verification error - let the component handle it
      if (errorData?.emailNotVerified) {
        return Promise.reject(error);
      }

      // If token expired, show friendly message
      if (errorData?.errorType === 'expired') {
        alert('⏱️ Votre session a expiré. Veuillez vous reconnecter.');
      }

      // Clear storage and force login
      localStorage.removeItem('currentUser');
      localStorage.removeItem('authToken');
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

export default axios;
